import Menu from '@mui/material/Menu'
import React, { memo } from 'react'
import tw from 'twin.macro'
import { PopoverOrigin, Typography } from '@mui/material'
import { MenuActionItem } from 'src/interfaces/ui'

interface Props {
  items: MenuActionItem[]
  isOpen?: boolean
  anchorEl?: any
  anchorOrigin?: PopoverOrigin
  transformOrigin?: PopoverOrigin
  itemClassName?: any
  onClose(): void
}

const ActionMenuComponent = ({
  items,
  isOpen,
  anchorEl,
  anchorOrigin,
  itemClassName,
  transformOrigin,
  onClose,
}: Props) => {
  return (
    <Menu
      id="menu-list"
      css={tw`mt-1.5 py-2`}
      open={Boolean(isOpen)}
      anchorEl={anchorEl}
      anchorOrigin={anchorOrigin}
      transformOrigin={transformOrigin}
      onClose={onClose}
      className="rounded-lg"
    >
      {items.map(({ label, color, icon, rightIcon, className, dataTestId, separator, onClick }) => (
        <div
          key={label}
          data-testid={dataTestId}
          css={[
            tw`px-3 flex`,
            itemClassName,
            className,
            onClick ? tw`hover:bg-[#F6F6F6] active:bg-[#B4AFC0] cursor-pointer` : undefined,
          ]}
          onClick={onClick}
        >
          <div
            css={[
              tw`flex items-center py-2 w-full`,
              separator === 'top'
                ? tw`border-0 border-t border-solid  border-[#EDEDED]`
                : undefined,
              separator === 'bottom'
                ? tw`border-0 border-b border-solid  border-[#EDEDED]`
                : undefined,
            ]}
          >
            {icon ? <div css={tw`w-5 h-5 items-center justify-center flex`}>{icon}</div> : null}
            <Typography css={icon && tw`ml-2`} variant="subtitle1" fontWeight={500} color={color}>
              {label}
            </Typography>
            {rightIcon}
          </div>
        </div>
      ))}
    </Menu>
  )
}

export const ActionMenu = memo(ActionMenuComponent)
